/**
 * Simple imports of the redux wrapped versions of the form fields.
 * These require no special handling as the Morpheus "nature" of these (e.g. compact) is handled in the core
 * component via the theme.
 */

import {
  AddressSuggestionFieldReduxFormWrapper as AddressSuggestionField,
  ButtonGroupFieldReduxFormWrapper as ButtonGroupField,
  CheckboxFieldReduxFormWrapper as CheckboxField,
  CurrencyInputFieldReduxFormWrapper as CurrencyInputField,
  DatePickerFieldReduxFormWrapper as DatePickerField,
  DropdownFieldReduxFormWrapper as DropdownField,
  DropzoneFieldReduxFormWrapper as DropzoneField,
  InputFieldReduxFormWrapper as InputField,
  DropdownInputFieldReduxFormWrapper as InputWithDropdownField,
  MaskedInputFieldReduxFormWrapper as MaskedInputField,
  NumberInputFieldReduxFormWrapper as NumberInputField,
  PasswordFieldReduxFormWrapper as PasswordField,
  RadioGroupFieldReduxFormWrapper as RadioGroupField,
  SearchFieldReduxFormWrapper as SearchField,
  TextAreaFieldReduxFormWrapper as TextAreaField,
  TimeFieldReduxFormWrapper as TimeField,
} from '@adc/ui-core'

/**
 * These field require a little handling.
 * RichTextField is unique to morpheus (not in core currently)
 */
import ListingSearchField from './listingSearchField'
import TransactionSearchField from './transactionSearchField'
import RichTextField, { TemplatingRichTextField } from './richTextField'

export default {
  AddressSuggestionField,
  ButtonGroupField,
  CheckboxField,
  CurrencyInputField,
  DatePickerField,
  DropdownField,
  DropzoneField,
  InputField,
  InputWithDropdownField,
  ListingSearchField,
  TransactionSearchField,
  MaskedInputField,
  NumberInputField,
  PasswordField,
  RadioGroupField,
  RichTextField,
  SearchField,
  TemplatingRichTextField,
  TextAreaField,
  TimeField,
}
